// extracted by mini-css-extract-plugin
export var footer = "_ow-5";
export var fulfillmentInput = "_ow-0";
export var shipDateInput = "_ow-1";
export var shipmentModal = "_ow-2";
export var shipmentModalContent = "_ow-3";
export var tableContainer = "_ow-4";